import { ReactElement } from "react";
import { ChevronDownIcon } from "staysure-component-library";

type AccordionProps = {
  title: ReactElement | string;
  content: ReactElement;
  icon?: ReactElement;
  id?: string;
  isexpanded?: boolean;
  onClick?: () => void;
  className?: string;
  contentClassName?: string;
  buttonClassName?: string;
  isShow?: boolean;
};

function Accordion({
  title,
  content,
  icon,
  id,
  isexpanded,
  onClick,
  className = "",
  contentClassName = "",
  buttonClassName = "",
  isShow = true,
}: Readonly<AccordionProps>) {
  return (
    <div
      className={`p-spacing-m md:p-spacing-l group ${className}`}
      id={`accordion-${id}`}
    >
      <button
        type="button"
        className={`w-full flex justify-between items-center outline-none group ${buttonClassName}`}
        onClick={onClick}
        id={`accordion-control-${id}`}
        aria-expanded={isexpanded}
        aria-controls={`${id}-panel`}
      >
        <span>{title}</span>
        {isShow && (
          <span
            className={`transition-transform duration-300 ${
              isexpanded ? "rotate-180" : "rotate-0"
            } group-focus-visible:outline group-focus-visible:outline-2 group-focus-visible:outline-interactive-focus-default`}
          >
            {icon ?? (
              <ChevronDownIcon className=" [&>path]:stroke-text-title" />
            )}
          </span>
        )}
      </button>
      <div
        id={`${id}-panel`}
        role="region"
        aria-labelledby={`accordion-control-${id}`}
        className={`${
          isexpanded
            ? `max-h-fit mt-spacing-l md:mt-spacing-m lg:mt-spacing-l ${contentClassName} overflow-x-visible`
            : "max-h-0 overflow-hidden"
        }`}
        hidden={!isexpanded}
        data-testid={`${id}-panel-test-id`}
      >
        <div
        // className={`transform transition duration-300 ease-in-out ${
        //   isexpanded ? "opacity-100 translate-y-0" : "opacity-0 translate-y-2"
        // }`}
        >
          {content}
        </div>
      </div>
    </div>
  );
}

export default Accordion;
